// uses ./adminToggle.less
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import t from '../../translations';

import Icon from '../common/Icon';
import { fetchUser, toggleAdminMode } from './userActionCreators';
import { storage } from '../common/platform/PlatformTools';

const AdminToggle = function (props) {
    if (!props.isAdmin) {
        return null;
    }

    let backOfficeButton;

    const backOfficeUrl = `${props.backOfficeUrl}?platformId=${storage.platformId}`;

    if (props.backOfficeUrl) {
        backOfficeButton = (
            <a className="sg-button-link adminToggle-button adminToggle-partner" href={backOfficeUrl}>
                <Icon alias="settings" /> Manage your App Definition
            </a>
        );
    }
    const toggleClassName = `adminToggle-toggle sg-toggle${props.actsAsAdmin ? ' sg-toggle--on' : ''}`;

    return (
        <div className="adminToggle">
            {backOfficeButton}
            <span>
                <Icon alias="account" />
                <span className="adminToggle-text">{t.user.adminMode} </span>
                <span className={toggleClassName} onClick={props.dispatchToggleAdminMode} />
            </span>
        </div>
    );
};

AdminToggle.propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    actsAsAdmin: PropTypes.bool.isRequired,
    backOfficeUrl: PropTypes.any,
    dispatchFetchUser: PropTypes.func.isRequired,
    dispatchToggleAdminMode: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchFetchUser: fetchUser,
    dispatchToggleAdminMode: toggleAdminMode,
};

export default connect((state) => state.user, mapDispatchToProps)(AdminToggle);
